import { PaymentMethod } from "../../../../common/enums";
import { type FormText } from "./types";

export const formTextMap = new Map<PaymentMethod, FormText>([
  [
    PaymentMethod.Check,
    {
      editWorkflowTitle: "Edit check instructions",
      paymentMethodText: "Check",
    },
  ],
  [
    PaymentMethod.ACH,
    {
      editWorkflowTitle: "Edit ACH direct deposit instructions",
      paymentMethodText: "ACH direct deposit",
    },
  ],
  [
    PaymentMethod.EFT,
    {
      editWorkflowTitle: "Edit Canada bank transfer (EFT) instructions",
      paymentMethodText: "Canada bank transfer (EFT)",
    },
  ],
  [
    PaymentMethod.Wire,
    {
      editWorkflowTitle: "Edit wire transfer instructions",
      paymentMethodText: "Wire transfer",
    },
  ],
  [
    PaymentMethod.BACS,
    {
      editWorkflowTitle: "Edit UK bank transfer instructions",
      paymentMethodText: "UK bank transfer (BACS/FPS/CHAPS)",
    },
  ],
  [
    PaymentMethod.BECS,
    {
      editWorkflowTitle: "Edit Australia direct entry instructions",
      paymentMethodText: "Australia direct entry (BECS)",
    },
  ],
  [
    PaymentMethod.SEPA,
    {
      editWorkflowTitle: "Edit Europe bank transfer (SEPA) instructions",
      paymentMethodText: "Europe bank transfer (SEPA)",
    },
  ],
  [
    PaymentMethod.Other,
    {
      editWorkflowTitle: "Edit payment instructions",
      paymentMethodText: "Other",
    },
  ],
]);
